export enum ActivityType {
  STANDARD = 'STANDARD',
  WITH_UNIT = 'WITH_UNIT'
}
